// ** Reducers Imports
import layout from "./layout";
import navbar from "./navbar";
import auth from "./auth";
import deposit from "./deposit";
import withdrawal from "./withdrawal";
import session from "./session";


const rootReducer = { navbar, layout, auth, deposit, withdrawal, session };

export default rootReducer;
